import { render, staticRenderFns } from "./MatchupBlockDefenderInfo.vue?vue&type=template&id=f1ed1882&scoped=true"
import script from "./MatchupBlockDefenderInfo.vue?vue&type=script&lang=ts"
export * from "./MatchupBlockDefenderInfo.vue?vue&type=script&lang=ts"
import style0 from "./MatchupBlockDefenderInfo.vue?vue&type=style&index=0&id=f1ed1882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ed1882",
  null
  
)

export default component.exports